import React, { useEffect, useState } from 'react';
import { connect } from 'shalala';

import { Http } from '../../../support';
import { useStore } from '../../../store';
import Loading from '../../../facturotopia/loading/Loading';
import LoadingButton from '../../../facturotopia/LoadingButton';
import ClienteTaxInfo from '../../clientes/info/ClienteTaxInfo';
import PageHeader from '../../../support/page-header/PageHeader';

const ReporteNuevoClienteInfo = (props) => {
  const { data } = props.info;

  const [busy, setBusy] = useState();

  useEffect(() => {
    window.setAppTitle('Nuevo cliente');

    const { data = {} } = props.location.state || {};

    if (!data.id) {
      const { id } = props.match.params;

      props.infoActions.info(id);
    } else {
      props.infoActions.setPartialState({ data });
    }
  }, []); // eslint-disable-line

  const handleOnChange = (event) => {
    activate();
  };

  const activate = async () => {
    setBusy(true);

    try {
      const params = {
        status: 1,
        comentario: 'Seguimiento completado.',
      };

      const response = await Http.patch(`api/clientes/${data.id}/status`, params);

      props.infoActions.setPartialState({ data: response.data });

      const fullList = props.list.data;

      const newList = fullList.filter((item) => data.id !== item.id);

      props.listActions.setPartialState({ data: newList });

      window.ToastManager.show({
        variant: 'success',
        title: 'Cambio de status',
        message: 'Actualización de status exitoso',
      });
    } catch (error) {
      const _error = error.data || error;

      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: _error.message || 'Error recuperando información del cliente',
      });
    } finally {
      setBusy(false);

      props.history.replace('/admin/reportes/clientes');
    }
  };

  if (busy) {
    return <Loading className="text-info" />;
  }

  return (
    <div>
      <PageHeader
        text="Nuevos Clientes"
        to="/admin/reportes/clientes"
      />

      <div className="d-block mt-3 mb-2">
        <strong className="text-muted">Detalles</strong>
      </div>

      <ClienteTaxInfo data={data}>
        <br />
        {data.status === 2 && (
          <LoadingButton
            type="button"
            loading={busy || false}
            onClick={handleOnChange}
          >
            {busy === true ? 'Guardando...' : 'Completar seguimiento'}
          </LoadingButton>
        )}
      </ClienteTaxInfo>
    </div>
  );
};

const mapState = (store) => {
  return {
    info: store.admin.reportes.clientes.info,
    list: store.admin.reportes.clientes.list,
  };
};

const mapActions = (actions) => {
  return {
    infoActions: actions.admin.reportes.clientes.info,
    listActions: actions.admin.reportes.clientes.list,
  };
};

export default connect(useStore, mapState, mapActions)(ReporteNuevoClienteInfo);
